export default "__VITE_ASSET__a34c3874__"